import styled from "styled-components";

export const Styles = styled.div`
  background: #ebebeb;
  border-radius: 4px;
  padding: 16px 20px 12px;
  margin-top: 24px;

  .status-title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .timeline {
    position: relative;
    height: 56px;

    .left-0-percentage {
      left: 0%;
    }
    .right-0-percentage {
      right: 0%;
    }
    .time-line-dot-start {
      position: absolute;
      left: 0%;
      top: -28px;
      transform: translateX(-14px);
    }

    .time-line-dot-end {
      position: absolute;
      right: 0%;
      top: -28px;
      transform: translateX(10px);
    }
  }

  .timeline-track {
    position: absolute;
    top: 26px;
    left: 0;
    right: 0;
    height: 2px;
    background: #1e3666;
  }

  .timeline-elapsed,
  .timeline-break {
    position: absolute;
  }

  .timeline-elapsed {
    top: -3px;
    height: 8px;
    background: #1e3666;
  }

  .timeline-break {
    top: 0;
    height: 2px;
    background: #1e3666;
  }

  .timeline-dot {
    position: absolute;
    top: 50%;
    width: 1px;
    height: 16px;
    background: #000;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  .timeline-label,
  .timeline-time,
  .timeline-now {
    position: absolute;
    white-space: nowrap;
  }

  .timeline-label {
    top: -4px;
    font-size: 14px;
    font-weight: 700;
  }

  .timeline-now {
    top: -20px;
    font-size: 20px;
    line-height: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }

  .timeline-now-time {
    font-size: 13px;
    line-height: 1;
  }

  .timeline-time {
    top: 40px;
    font-size: 13px;
  }
`;
